module.exports = __webpack_public_path__ + "img/fashion_70.a2423eec.jpg";